import React, { ReactNode } from "react";
import classes from "./ViewerProps.module.css";
import { togglePropSet } from "../../../app/features/viewer/propsSlice/propsSlice";
import { useAppDispatch } from "../../../app/hooks/hooks";
interface ViewerPropsSetTitleProps {
    children: ReactNode;
    hidden: boolean;
}
function ViewerPropsSetTitle({
    children,
    hidden = false,
}: ViewerPropsSetTitleProps) {
    const dispatch = useAppDispatch();
    return (
        <div
            className={[
                classes.setNameTitle,
                hidden ? classes.setHidden : "",
            ].join(" ")}
            onClick={() => {
                dispatch(togglePropSet(children ? children.toString() : ""));
            }}
        >
            {children}
        </div>
    );
}

export default ViewerPropsSetTitle;
